import { CircleCheck } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'
import { TASK_STATUS_FILTER_OPTIONS } from '../workflows/WorkflowVisualIndicators'

const TasksStatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = TASK_STATUS_FILTER_OPTIONS?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Status', options: filteredOptions || [] }]}
        placeholder='Search statuses to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={TASK_STATUS_FILTER_OPTIONS || []}
          noSelectionText='Task Status'
          pluralIdentifier='task statuses'
        >
          <CircleCheck size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default TasksStatusFilter
